module.exports = __webpack_public_path__ + "37ac03eed2cbf4a898af1a5db22833b5.svg";